export const GET_PRISM_VERSION = 'GET_PRISM_VERSION';
export const PRISM_VERSION = 'PRISM_VERSION';
export const CUSTOM_LOGIN = 'CUSTOM_LOGIN';
export const GET_SYSTEM_CONFIG = 'GET_SYSTEM_CONFIG';
export const IS_RETURN_USER = 'IS_RETURN_USER';
export const TRUE = 'TRUE';
export const WELCOME_BANNER_HAS_TRIGGERED = 'WELCOME_BANNER_HAS_TRIGGERED';
export const GET_PRISM_LOGIN_CUSTOM = 'GET_PRISM_LOGIN_CUSTOM';
